class ReadMoreDescription extends HTMLElement {
  connectedCallback() {
    this.wordLimit = parseInt(this.dataset.wordLimit, 10) || 40;
    this.contentEl = this.querySelector('[data-description-content]');
    this.button = this.querySelector('[data-description-toggle]');
    this.labelMore = this.button ? this.button.querySelector('[data-label-more]') : null;
    this.labelLess = this.button ? this.button.querySelector('[data-label-less]') : null;

    if (!this.contentEl) return;

    this.truncate();

    if (this.button) {
      this.button.addEventListener('click', () => this.toggle());
    }
  }

  countWords(str) {
    return str.trim().split(/\s+/).filter(Boolean).length;
  }

  truncate() {
    const totalWords = this.countWords(this.contentEl.textContent || '');
    const remainderWords = totalWords - this.wordLimit;

    // If there's barely anything left to hide, don't bother truncating at all.
    if (remainderWords <= 3) return;

    const walker = document.createTreeWalker(this.contentEl, NodeFilter.SHOW_TEXT, null);
    let wordCount = 0;
    let cutNode = null;
    let cutOffset = -1;

    while (walker.nextNode()) {
      const node = walker.currentNode;
      const parts = node.textContent.split(/(\s+)/);
      let runningLength = 0;

      for (let i = 0; i < parts.length; i++) {
        const part = parts[i];
        runningLength += part.length;
        if (part.trim() === '') continue;
        wordCount++;
        if (wordCount === this.wordLimit) {
          cutNode = node;
          cutOffset = runningLength;
          break;
        }
      }
      if (cutNode) break;
    }

    if (!cutNode) return;

    const range = document.createRange();
    range.setStart(cutNode, cutOffset);
    range.setEndAfter(this.contentEl.lastChild);
    const remainderFragment = range.extractContents();

    this.hiddenWrapper = document.createElement('span');
    this.hiddenWrapper.className = 'read-more-description__hidden-text';
    this.hiddenWrapper.hidden = true;
    this.hiddenWrapper.appendChild(remainderFragment);

    this.ellipsis = document.createElement('span');
    this.ellipsis.className = 'read-more-description__ellipsis';
    this.ellipsis.textContent = '\u2026';

    this.cutParent = cutNode.parentNode;
    this.cutParent.insertBefore(this.ellipsis, cutNode.nextSibling);
    this.cutParent.insertBefore(this.hiddenWrapper, this.ellipsis.nextSibling);

    if (this.button) {
      this.cutParent.insertBefore(this.button, this.hiddenWrapper);
      this.button.hidden = false;
    }
  }

  toggle() {
    if (!this.hiddenWrapper) return;
    const isCollapsed = this.hiddenWrapper.hidden;

    this.hiddenWrapper.hidden = !isCollapsed;
    this.ellipsis.hidden = isCollapsed;
    if (this.labelMore) this.labelMore.hidden = isCollapsed;
    if (this.labelLess) this.labelLess.hidden = !isCollapsed;

    if (this.button) {
      if (isCollapsed) {
        // Expanding: move the button to the very end of the full text.
        this.contentEl.appendChild(this.button);
      } else {
        // Collapsing: move the button back next to the truncation point.
        this.cutParent.insertBefore(this.button, this.hiddenWrapper);
      }
    }
  }
}

if (!customElements.get('read-more-description')) {
  customElements.define('read-more-description', ReadMoreDescription);
}
